// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "header-1kvlB";
var _3 = "text-PP1NA";
var _4 = "flight-2dUdz";
var _5 = "flight_label-20Sd4";
var _6 = "checkbox-ncrIR";
var _7 = "checkbox_checked-9ppkM";
var _8 = "passengers-1s2o3";
var _9 = "passengers_item-3U5Zf";
var _a = "total-2FLz8";
export { _1 as "__esModule", _2 as "header", _3 as "text", _4 as "flight", _5 as "flight_label", _6 as "checkbox", _7 as "checkbox_checked", _8 as "passengers", _9 as "passengers_item", _a as "total" }
export default { "__esModule": _1, "header": _2, "text": _3, "flight": _4, "flight_label": _5, "checkbox": _6, "checkbox_checked": _7, "passengers": _8, "passengers_item": _9, "total": _a }
